
import CustomButton from './elements/CustomButton/CustomButton';

function SessionTimeout({ onClose }) {
    return (
        <div className="pt-6 px-10" >
                <div className="flex justify-center w-full text-3xl font-[600]" >Oops! Your session timed out.</div>
            <div className='flex flex-col my-4 w-full justify-center items-center' >
                <div className='mb-6 text-center'>It looks like you've been inactive for a while. To keep your account
                    secure, we've logged you out. Please log in to pick up where you left
                    off.</div>
                    <CustomButton
                         onClick={() => onClose()}
                        customeClass={`gradient-button w-[150px] h-[40px]`}
                    >
                        Sign In Back
                    </CustomButton>
            </div>
        </div>
    );
}

export default SessionTimeout;